export const MEETING_ANALYSIS_NAMESPACE_INJECTION_TOKEN$ = 'MEETING_ANALYSIS_NAMESPACE';
export const MEETING_ANALYSIS_ROUTE_PREFIX$ = 'MEETING_ANALYSIS_ROUTE_PREFIX';
